import { render, staticRenderFns } from "./-oz-rich-mobile-modal.vue?vue&type=template&id=48f98ae8&scoped=true&"
import script from "./-oz-rich-mobile-modal.vue?vue&type=script&lang=ts&"
export * from "./-oz-rich-mobile-modal.vue?vue&type=script&lang=ts&"
import style0 from "./-oz-rich-mobile-modal.vue?vue&type=style&index=0&id=48f98ae8&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f98ae8",
  null
  
)

export default component.exports